// src/components/LoadingSpinner.js
import React from 'react';
import { motion } from 'framer-motion';

const LoadingSpinner = () => (
  <div className="flex flex-col justify-center items-center h-screen bg-background">
    <motion.div
      className="w-16 h-16 border-4 border-primary-200 border-t-primary-600 rounded-full"
      animate={{ rotate: 360 }}
      transition={{ duration: 1, repeat: Infinity, ease: 'linear' }}
    />
    <motion.p
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.5 }}
      className="mt-4 text-gray-600 font-medium"
    >
      Loading...
    </motion.p>
  </div>
);

export default LoadingSpinner;
